import {
	ProductChangeEventArgs,
	QuoteData,
	RefundableProvider,
	useRefundableActions
} from 'protect-group-pulse-react'
import {options, sessionKeys} from '../data'
import FormInput from '../components/ui/FormInput'
import {useEffect, useState} from 'react'
import Button from '../components/ui/Button'

function PatchSaleDev() {
	const [saleId, setSaleId] = useState<string>('')
	const {patchSale, updateQuoteData} = useRefundableActions()

	useEffect(() => {
		setSaleId(sessionStorage.getItem(sessionKeys.bookingReference) ?? '')

		const eventArgs: ProductChangeEventArgs = JSON.parse(sessionStorage.getItem(sessionKeys.eventArgs) ?? '{}')
		const quoteData: QuoteData = JSON.parse(sessionStorage.getItem(sessionKeys.quoteData) ?? '{}')

		updateQuoteData({
			...quoteData,
			quoteId: eventArgs.quoteId
		})
	}, [])

	const handleClick = async () => {
		try {
			const eventArgs: ProductChangeEventArgs = JSON.parse(sessionStorage.getItem(sessionKeys.eventArgs) ?? '{}')

			const response = await patchSale({
				bookingReference: saleId,
				quoteId: eventArgs.quoteId ?? '',
				customers: [
					{ firstName: 'Patch', lastName: 'McPatchFace' }
				],
				products: (eventArgs.products ?? []).map(x => ({
					productCode: x.productCode,
					productId: x.productId,
					sold: x.sold === true
				}))
			})
			console.log('Patch Sale Response', response)
		} catch (err) {
			console.error('Patch failed', err)
		}
	}

	return (
		<div className="flex flex-col">
			<div>
				<FormInput
					id="bookingRefereence"
					label="Booking Reference"
					onChange={(evt) => setSaleId(evt.target.value)}
					value={saleId}
				/>
			</div>
			<div>
				<Button
					label="Patch Sale"
					onClick={handleClick}
				/>
			</div>
			<div></div>
		</div>
	)
}

export default function PatchSale() {
	return (
		<div className="flex flex-col h-screen w-full">
			<h2 className="mb-3 pb-3 pt-4 border-b-2 border-sky-500 text-lg text-center">Patch Sale</h2>
			<div className="p-4">
				<RefundableProvider options={options}>
					<PatchSaleDev/>
				</RefundableProvider>
			</div>
		</div>
	)
}
